module.exports = __webpack_public_path__ + "static/media/14_negro.ef47ac4c.svg";